import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "../pages/login/Login";
import RecuperarSenha from "../pages/recuperarSenha/RecuperarSenha";
import NovaSenha from "../pages/novaSenha/NovaSenha";
import RedefinirInformacoesUsuarioPrimeiroLogin from "../pages/redefinirInformacoesUsuarioPrimeiroLogin/RedefinirInformacoesUsuarioPrimeiroLogin";
import ProtectedRoutePrimeiroLogin from "./ProtectedRoutePrimeiroLogin";
import RedefinirSenha from "../pages/redefinirSenhaUsuario/RedefinirSenhaUsuario";
import Termos from "../pages/termos/Termos";

function Rotas() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Rota que bloqueia acesso a outras páginas durante o primeiro login */}

        <Route element={<ProtectedRoutePrimeiroLogin />}>
          <Route path="/redefinirInformacoes" element={<RedefinirInformacoesUsuarioPrimeiroLogin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/esqueciSenha" element={<RecuperarSenha />} />
          <Route path="/novaSenha" element={<NovaSenha />} />
          <Route path="/dashboard" element={<h1>Teste</h1>} />
          <Route path="*" element={<Navigate to="/login" />} />
          <Route path="/redefinir/senha" element={<RedefinirSenha />} />
          <Route path="/termos" element={<Termos />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Rotas;
